import React from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiMapPin, FiStar, FiBarChart2, FiShare2, FiVideo, FiGlobe} = FiIcons;

const services = [
  {icon: FiMapPin, number: '01', title: 'A fully managed Google profile', description: 'We optimize your description, services, attributes and links; write and publish posts; and keep photos, videos and offers flowing. Review posts first if you prefer.'},
  {icon: FiStar, number: '02', title: 'Reviews & reputation', description: 'Request reviews by text, email or WhatsApp, follow up, and reply in your voice. Get a custom review link, printable QR code, review backups and help flagging policy-violating reviews.'},
  {icon: FiBarChart2, number: '03', title: 'Rankings you can see', description: 'Monthly local ranking heatmaps, before-and-after snapshots and tracking for up to 10 keywords, plus weekly progress emails and an activity log.'},
  {icon: FiShare2, number: '04', title: 'Social posts without extra work', description: 'Keep Facebook and Instagram active with content repurposed from your local updates. Turn great reviews into posts, too.'},
  {icon: FiVideo, number: '05', title: 'Short-form promo videos', description: 'Turn your photos into short videos with AI voiceover and publish them across YouTube, Google and social channels.'},
  {icon: FiGlobe, number: '06', title: 'Content beyond your profile', description: 'Add a search-friendly website FAQ, ready-to-paste schema markup and widgets for your posts, reviews and photos.'}
];

export default function ServicesSection() {
  return (
    <section id="services" className="bg-[#101c2d] py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-12 flex flex-col justify-between gap-5 lg:flex-row lg:items-end">
          <div>
            <p className="mb-4 text-xs font-bold uppercase tracking-[0.2em] text-[#3fc0fa]">What we manage</p>
            <h2 className="max-w-2xl text-4xl font-black leading-tight tracking-tight text-white sm:text-5xl lg:text-6xl">
              All the little things that make a <span className="text-[#3fc0fa]">big local difference.</span>
            </h2>
          </div>
          <p className="max-w-sm text-lg text-slate-400">Consistent activity across search, reviews and social—without adding another job to your day.</p>
        </div>
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {services.map((service, index) => (
            <motion.div
              key={service.number}
              initial={{opacity: 0, y: 18}}
              whileInView={{opacity: 1, y: 0}}
              viewport={{once: true}}
              transition={{delay: index * 0.05}}
              className="rounded-2xl border border-white/10 bg-[#19283d] p-7 transition-colors hover:border-[#3fc0fa]/60 sm:p-8"
            >
              <div className="mb-10 flex items-start justify-between">
                <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-[#3fc0fa]/10">
                  <SafeIcon icon={service.icon} className="h-6 w-6 text-[#3fc0fa]" />
                </div>
                <span className="text-xs font-bold text-slate-500">{service.number}</span>
              </div>
              <h3 className="mb-3 text-xl font-bold text-white">{service.title}</h3>
              <p className="text-sm leading-relaxed text-slate-400">{service.description}</p>
            </motion.div>
          ))}
        </div>
        <p className="mt-8 text-sm text-slate-400">Photos can be prepared with location and keyword metadata before upload. Visibility in AI search can be monitored, but rankings and inclusion are not guaranteed.</p>
      </div>
    </section>
  );
}